export class MUDError extends Error {
  name = "MUDError";
}
